import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormButton from 'components/form-components/FormButton';
import { Calendar, DateObject } from 'react-multi-date-picker';
import 'react-multi-date-picker/styles/colors/green.css';

const DateRangeSelector = ({ name, value, onChange, onClose }) => {
  const [dates, setDates] = useState([]);

  const handleSubmit = () => {
    const [start, end] = dates;
    const startDate = start.toDate();
    const endDate = end.toDate();
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    const formatted = [startDate.toISOString(), endDate.toISOString()];

    onChange(name, formatted);
    onClose();
  };

  useEffect(() => {
    if (value.length === 2) {
      const modifiedValue = value.map((v) => new DateObject(v));
      setDates(modifiedValue);
    }
  }, [value]);

  // this will only affect on first render
  let selectedDateStartFrom = new DateObject();
  if (value.length === 2) {
    selectedDateStartFrom = new DateObject(value[0]);
  }

  return (
    <div className='d-flex flex-column gap-3 mx-3 my-2'>
      <Calendar
        className='all-elements-color-unset green'
        value={dates}
        onChange={setDates}
        range
        numberOfMonths={2}
        currentDate={selectedDateStartFrom}
      />
      <FormButton
        text='Done'
        variant='green-1'
        onClick={handleSubmit}
        classes='ms-auto'
        disabled={dates.length < 2}
      />
    </div>
  );
};

DateRangeSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DateRangeSelector;
